export const SNAP_INTERVAL_MINS = 60;
export const SNAP_INTERVAL_MILLIS = SNAP_INTERVAL_MINS * 60 * 1000;
export const getSnapIntervalHeight = hourHeight => hourHeight * SNAP_INTERVAL_MINS / 60;